import React from 'react';
import { useInView } from 'react-cool-inview';
import { Breakpoint } from 'types/utils';

type UseStickyPanelTopStateResult = {
  stickyPanelSentinelRef: React.RefObject<HTMLDivElement>;
  isStickyAtTop: boolean;
};

export const useStickyPanelTopState = (breakpoint: Breakpoint | null): UseStickyPanelTopStateResult => {
  const stickyPanelSentinelRef = React.useRef<HTMLDivElement>(null);
  const [isStickyAtTop, setIsStickyAtTop] = React.useState(false);

  const { observe: observeStickyPanelTop, unobserve: unobserveStickyPanelTop } = useInView({
    rootMargin: '-1px 0px 0px 0px',
    threshold: 0,
    onEnter: () => setIsStickyAtTop(false),
    onLeave: () => setIsStickyAtTop(true),
  });

  React.useEffect(() => {
    const sentinel = stickyPanelSentinelRef.current;

    if (!sentinel || breakpoint === 'mobile' || breakpoint === 'tablet' || breakpoint === null) {
      setIsStickyAtTop(false);
      return;
    }
    observeStickyPanelTop(sentinel);

    return () => {
      unobserveStickyPanelTop();
    };
  }, [breakpoint, observeStickyPanelTop, unobserveStickyPanelTop]);

  return {
    stickyPanelSentinelRef,
    isStickyAtTop,
  };
};
